"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var duration = {
  fast: 120,
  medium: 200,
  mediumSlow: 400,
  slow: 500
};
var cubicBezier = {
  default: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  fastOutSlowIn: 'cubic-bezier(0.4, 0, 0.2, 1)'
};
var _default = {
  cubicBezier: cubicBezier,
  duration: duration,
  transitionFast: "".concat(duration.fast, "ms ").concat(cubicBezier.default),
  transitionMedium: "".concat(duration.medium, "ms ").concat(cubicBezier.default),
  transitionSlow: "".concat(duration.slow, "ms ").concat(cubicBezier.default)
};
exports.default = _default;